import APIClient from "../../APIClient";

const ajaxCache = {};

const serialize = obj =>
  Object.keys(obj)
    .reduce((arr, key) => arr.concat(`${key}=${obj[key]}`), [])
    .join("&");

const getURL = (url, method, params = {}) => {
  if (method === "get") {
    return `${url}?${serialize(params)}`;
  }

  return url;
};

const api = (url, method = "get", params = {}) => {
  const parsedURL = getURL(url, method, params);
  return APIClient[method](parsedURL, params);
};

const checkValidAction = action => {
  const VALID_KEYS = ["type", "ajax"];

  const unknownKeys = Object.keys(action).filter(key => VALID_KEYS.indexOf(key) === -1);

  if (unknownKeys.length) {
    const msg = `
    Unknown keys found on
    action: ${unknownKeys.join(", ")}
    `;

    throw new Error(msg);
  }
};

const ajaxMiddleware = ({ dispatch }) => next => action => {
  if (!action || !action.ajax) {
    return next(action);
  }

  checkValidAction(action);

  const { type, ajax: { cache, url, method, meta, params } } = action;

  const PENDING = `${type}_PENDING`;
  const SUCCESS = `${type}_SUCCESS`;
  const FAILURE = `${type}_FAILURE`;

  const cacheKey = getURL(url, method, params);

  if (cache && method === "get" && ajaxCache[cacheKey]) {
    dispatch({
      meta,
      type: PENDING,
    });

    dispatch({
      meta,
      data: ajaxCache[cacheKey],
      type: SUCCESS,
    });

    return Promise.resolve(ajaxCache[cacheKey]);
  }

  dispatch({
    meta,
    type: PENDING,
  });

  return api(url, (method || "get").toLowerCase(), params)
    .then(data => {
      if (cache && method === "get") {
        ajaxCache[cacheKey] = data;
      }

      dispatch({
        meta,
        data,
        type: SUCCESS,
      });

      return data;
    })
    .catch(error => {
      dispatch({
        meta,
        error,
        type: FAILURE,
      });

      throw error;
    });
};

export default ajaxMiddleware;
